<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section bg-chsc-raw">
        <UiContainer max-width="max-w-3xl">
            <header class="global-header z-1 relative">
                <StoryblokRichText :doc="blok?.header" />
            </header>
        </UiContainer>
        <UiContainer max-width="max-w-5xl">
            <div class="mt-20">
                <h3 class="text-center text-chsc-indigo-500 fs-5xl font-londrina-solid mb-12">
                    {{ blok?.uk_title }}
                </h3>
                <div class="flex flex-wrap -m-12">
                    <div class="w-1/2 p-12 max-[769px]:w-full">
                        <div class="flex gap-x-2.5 max-[769px]:justify-center">
                            <img
                                v-motion-slide-visible-once-bottom
                                :src="blok?.uk_ferrero_image.filename"
                                :alt="blok?.uk_ferrero_image.alt"
                                class="h-[234px]"
                            >
                            <div class="text-chsc-indigo-500 [&>p]:leading-[76px] [&>p]:font-londrina-solid [&>p]:text-[88px] [&>h6]:font-montserrat [&>h6]:text-[105px] [&>h6]:leading-[120px] [&>h6]:text-chsc-yellow [&>h6>strong]:text-[165px] [&>h6>strong]:leading-[120px]  [&>h6>strong]:font-londrina-solid [&>h6>strong]:text-chsc-indigo-500 max-[1025px]:[&>h6]:text-[100px] max-[1025px]:[&>p]:text-[50px]">
                                <StoryblokRichText :doc="blok?.uk_ferrero_data" />
                            </div>
                        </div>
                        <div>
                            <p class="font-eb-garamond text-3xl max-[769px]:text-center">
                                {{ blok?.uk_ferrero_description }}
                            </p>
                        </div>
                    </div>
                    <div class="w-1/2 p-12 max-[769px]:w-full">
                        <div class="flex gap-x-2.5 max-[769px]:justify-center">
                            <img
                                v-motion-slide-visible-once-bottom
                                :src="blok?.uk_creme_image.filename"
                                :alt="blok?.uk_creme_image.alt"
                                class="h-[234px]"
                            >
                            <div class="text-chsc-indigo-500 [&>p]:leading-[76px] [&>p]:font-londrina-solid [&>p]:text-[88px] [&>h6]:font-montserrat [&>h6]:text-[105px] [&>h6]:leading-[120px] [&>h6]:text-chsc-yellow [&>h6>strong]:text-[165px] [&>h6>strong]:leading-[120px]  [&>h6>strong]:font-londrina-solid [&>h6>strong]:text-chsc-indigo-500 max-[1025px]:[&>h6]:text-[100px] max-[1025px]:[&>p]:text-[50px]">
                                <StoryblokRichText :doc="blok?.uk_creme_data" />
                            </div>
                        </div>
                        <div>
                            <p class="font-eb-garamond text-3xl max-[769px]:text-center">
                                {{ blok?.uk_creme_description }}
                            </p>
                        </div>
                    </div>
                    <div class="w-full p-12">
                        <header class="mb-6 text-center text-[88px] font-londrina-solid leading-[76px] text-chsc-indigo-500 [&>h3>strong]:font-normal [&>h3>strong]:text-chsc-yellow max-[1025px]:fs-8xl">
                            <StoryblokRichText :doc="blok?.uk_milka_title" />
                        </header>
                        <div class="flex items-center justify-center">
                            <img
                                v-motion-slide-visible-once-bottom
                                :src="blok?.uk_milka_image.filename"
                                :alt="blok?.uk_milka_image.alt"
                                class="h-[200px]"
                            >
                            <div class="-ml-1 h-[185px] flex items-center justify-center px-4 bg-[#9780BC] border-dashed border-2 border-chsc-indigo-500">
                                <p class="font-londrina-solid text-chsc-yellow fs-5xl">
                                    -{{ blok?.uk_milka_percent }}%
                                </p>
                            </div>
                        </div>
                        <div class="max-w-3xl mt-8 mx-auto">
                            <p class="font-eb-garamond fs-3xl text-center">
                                {{ blok?.uk_milka_description }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </UiContainer>
        <UiContainer>
            <header class="mt-20 mb-12 text-center [&>h3]:font-londrina-solid [&>h3]:text-chsc-indigo-500 [&>h3]:fs-5xl [&>h3>strong]:text-chsc-yellow [&>h3>strong]:font-normal">
                <StoryblokRichText :doc="blok?.struggling_header" />
            </header>
            <div class="flex flex-wrap -m-6">
                <div
                    v-for="item in 3"
                    :key="item"
                    class="w-1/3 p-6 max-[769px]:w-full"
                >
                    <div class="min-h-full relative border-[2px] border-chsc-indigo-500 rounded-[40px] py-14 px-8 text-center">
                        <header class="absolute top-0 left-0 w-full flex items-center justify-center -translate-y-1/2">
                            <h5 class="text-chsc-indigo-500 fs-3xl font-londrina-solid bg-chsc-raw px-4">
                                {{ blok?.[`struggling_company${item}_name`] }}
                            </h5>
                        </header>
                        <div class="[&>h5]:leading-[80px] [&>h5]:font-londrina-solid [&>h5]:fs-9xl [&>h5]:text-chsc-yellow [&>h5>strong]:text-chsc-indigo-500 [&>h5>strong]:font-normal [&>h6]:font-londrina-solid [&>h6]:fs-5xl [&>h6]:text-chsc-yellow [&>h6>strong]:text-chsc-indigo-500 [&>h6>strong]:font-normal &>h6]:leading-[40px] [&>p]:mt-6 [&>p]:font-eb-garamond [&>p]:fs-3xl">
                            <StoryblokRichText :doc="blok?.[`struggling_company${item}_description`]" />
                        </div>
                    </div>
                </div>
            </div>
        </UiContainer>
        <UiContainer>
            <div class="mt-20 bg-chsc-yellow rounded-[40px] py-5 px-20 max-[641px]:px-6">
                <div class="flex items-center max-[769px]:flex-col max-[769px]:gap-y-4">
                    <p class="font-londrina-solid fs-5xl text-chsc-indigo-500 max-[769px]:text-center max-[769px]:fs-5xl!">
                        {{ blok?.farmers_claim }}
                    </p>
                    <img
                        v-motion-slide-visible-once-bottom
                        :src="blok?.farmers_image.filename"
                        :alt="blok?.farmers_image.alt"
                    >
                </div>
            </div>
        </UiContainer>
        <UiContainer>
            <div class="mt-20">
                <header>
                    <h3 class="mb-14 text-chsc-indigo-500 fs-4xl font-londrina-solid">
                        {{ blok?.profit_title }}
                    </h3>
                </header>
                <div>
                    <div class="flex flex-wrap -m-6">
                        <div
                            v-for="item in 4"
                            :key="item"
                            class="w-1/2 p-6 max-[769px]:w-full"
                        >
                            <div class="min-h-full relative border-[2px] border-chsc-indigo-500 rounded-[40px] py-14 px-8 text-center">
                                <header class="absolute top-0 left-0 w-full flex items-center justify-center -translate-y-1/2">
                                    <h5 class="text-chsc-indigo-500 fs-3xl font-londrina-solid bg-chsc-raw px-4">
                                        {{ blok?.[`profit_${item}_title`] }}
                                    </h5>
                                </header>
                                <div class="flex flex-wrap items-center -mx-4">
                                    <div class="w-4/12 p-4 flex justify-center max-[641px]:w-full">
                                        <img
                                            v-motion-slide-visible-once-bottom
                                            :src="blok?.[`profit_${item}_image`].filename"
                                            :alt="blok?.[`profit_${item}_image`].alt"
                                        >
                                    </div>
                                    <div class="w-8/12 p-4 max-[641px]:w-full">
                                        <p class="fs-3xl font-eb-garamond">
                                            {{ blok?.[`profit_${item}_description`] }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </UiContainer>
        <UiContainer>
            <div class="bg-chsc-indigo-500 rounded-[40px] p-24 overflow-hidden">
                <div class="grid grid-cols-2 gap-x-12 items-center ">
                    <div class="relative">
                        <div class="absolute -bottom-44 right-0 z-0">
                            <img
                                :src="blok?.cheaper_image.filename"
                                :alt="blok?.cheaper_image.alt"
                                class="mx-auto"
                            >
                        </div>
                        <div class="relative z-1 text-left font-londrina-solid text-white  [&>h6]:fs-6xl [&>h6]:leading-[48px] [&>*>strong]:text-chsc-yellow [&>h5]:text-[140px] [&>h5]:leading-[120px] [&>p]:leading-[36px]">
                            <StoryblokRichText :doc="blok?.cheaper_title" />
                        </div>
                        
                    </div>
                    <div class="[&>p]:font-eb-garamond [&>p]:fs-2xl [&>p]:text-white">
                        <StoryblokRichText :doc="blok?.cheaper_description" />
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
